"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClickOutside = void 0;
var react_1 = require("react");
/**
 * Executes the provided `callback` if a click event occurs outside of the DOM node
 * associated with the provided `ref`.
 */
var useClickOutside = function (ref, callback) {
    var handleClick = function (e) {
        if (ref.current && !ref.current.contains(e.target)) {
            callback();
        }
    };
    (0, react_1.useEffect)(function () {
        document.addEventListener('click', handleClick);
        return function () {
            document.removeEventListener('click', handleClick);
        };
    });
};
exports.useClickOutside = useClickOutside;
